import { createRoot } from 'react-dom/client'
import App from './app';

import hljs from "highlight.js";
import "highlight.js/styles/github.css"; // or another theme

// Reference to use in code this import
(window as { hljs?: typeof hljs }).hljs = hljs;

const refreshToken = () => {
  // Only attempt a refresh when a session is likely active (username cookie is
  // set on login) — otherwise every 5-minute tick spams 401s in the server log
  const hasSession = document.cookie.split('; ').some(row => row.startsWith('username='));
  if (!hasSession) return;
  fetch('/auth/refresh', {
    method: 'POST',
    credentials: 'include',
  })
  .then(response => {
    if (!response.ok) {
      console.error('Failed to refresh token');
    }
  })
  .catch(error => {
    console.error('Error refreshing token:', error);
  });
}

//also refresh token on page load (content visibility change event or newver api)
document.addEventListener('visibilitychange', () => {
  if (document.visibilityState === 'visible') {
    refreshToken();
  }
});

setInterval(refreshToken, 5 * 60 * 1000); // Refresh every 5 minutes

const setVhVariableMobileFix = () => {
  // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
  const vh = window.innerHeight * 0.01;
  // Then we set the value in the --vh custom property to the root of the document
  document.documentElement.style.setProperty('--vh', `${vh}px`);
};

// We listen to the resize event
window.addEventListener('resize', () => {
  // We execute the same script as before
  setVhVariableMobileFix();
});
setVhVariableMobileFix();

createRoot(document.getElementById('react-app')!).render(  
  <App />,
);
